export default function SecuritySection() {
  return (
    <section id="security" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 items-center">
          <div className="flex-1">
            <span className="inline-block text-xs font-semibold tracking-wider uppercase text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-4">
              Security &amp; Trust
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6">
              Your Data Safety Is Our Priority
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                When using <strong className="text-foreground-900">Basetao Spreadsheet</strong>, your personal and order data is protected with industry-standard encryption protocols. All spreadsheet data is transmitted over secure HTTPS connections, and access controls ensure that only authorized users can view or modify your information.
              </p>
              <p>
                The platform adheres to strict privacy protection standards, meaning your order details, shipping addresses, and payment information are never shared with third parties without your explicit consent. Basetao employs regular security audits and vulnerability assessments to maintain the highest level of data safety.
              </p>
              <p>
                For spreadsheet-specific security, all templates and shared documents include granular permission settings. You control who can view, edit, or comment on your procurement lists, making it safe for business teams to collaborate without risking data exposure to competitors or unauthorized individuals.
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              {[
                { icon: 'ri-lock-line', text: 'End-to-End Encryption' },
                { icon: 'ri-user-settings-line', text: 'Granular Access Control' },
                { icon: 'ri-shield-line', text: 'Regular Security Audits' },
                { icon: 'ri-file-shield-line', text: 'GDPR Compliant' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2 text-xs md:text-sm text-foreground-700 bg-background-50 px-3 py-2 rounded-lg border border-background-200/70">
                  <i className={`${item.icon} w-4 h-4 flex items-center justify-center text-secondary-600`}></i>
                  <span className="whitespace-nowrap">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[340px] flex-shrink-0">
            <div className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 p-6">
              <div className="w-16 h-16 rounded-2xl bg-secondary-100 flex items-center justify-center mb-4">
                <i className="ri-shield-check-line w-8 h-8 flex items-center justify-center text-secondary-700"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Safe Spreadsheet Practices</h3>
              <ul className="space-y-3">
                {[
                  'Never share spreadsheet links publicly',
                  'Use two-factor authentication for your account',
                  'Regularly review shared access permissions',
                  'Export backups before major modifications',
                  'Verify formulas before bulk operations',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-foreground-600">
                    <i className="ri-check-line w-4 h-4 flex items-center justify-center text-secondary-600 mt-0.5 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}